import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { QuickActionType } from "../types";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";
export var useModalContent = function useModalContent() {
  var _quickActions$QuickAc, _quickActions$QuickAc2, _quickActions$QuickAc3, _quickActions$QuickAc4, _quickActions$QuickAc5, _quickActions$QuickAc6, _quickActions$QuickAc7, _quickActions$QuickAc8;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var retailerQuickActions = useRetailerQuickActions();
  var brandQuickActions = useBrandQuickActions();
  var quickActions = _objectSpread(_objectSpread({}, retailerQuickActions), brandQuickActions);
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.ACCEPT_AN_ORDER, {
    title: (_quickActions$QuickAc = quickActions[QuickActionType.ACCEPT_AN_ORDER]) === null || _quickActions$QuickAc === void 0 ? void 0 : _quickActions$QuickAc.label,
    description: strictLocalize({
      id: "ou6wIg",
      defaultMessage: [{
        "type": 0,
        "value": "Aceitar novas encomendas fornecendo uma estimativa de envio"
      }]
    }),
    buttonText: strictLocalize({
      id: "5e09EO",
      defaultMessage: [{
        "type": 0,
        "value": "Fornecer estimativa de envio"
      }]
    })
  }), QuickActionType.REQUEST_COMMISSION_CHANGE, {
    title: (_quickActions$QuickAc2 = quickActions[QuickActionType.REQUEST_COMMISSION_CHANGE]) === null || _quickActions$QuickAc2 === void 0 ? void 0 : _quickActions$QuickAc2.label,
    description: strictLocalize({
      id: "rAF6ME",
      defaultMessage: [{
        "type": 0,
        "value": "Solicite uma atualização de comissão do Faire Direct sobre encomendas dos retailers com os quais já tenha um relacionamento comercial."
      }]
    }),
    buttonText: strictLocalize({
      id: "cX24dx",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar pedido de atualização da comissão"
      }]
    })
  }), QuickActionType.EDIT_ITEM_AVAILABILITY, {
    title: (_quickActions$QuickAc3 = quickActions[QuickActionType.EDIT_ITEM_AVAILABILITY]) === null || _quickActions$QuickAc3 === void 0 ? void 0 : _quickActions$QuickAc3.label,
    description: strictLocalize({
      id: "b1DBx0",
      defaultMessage: [{
        "type": 0,
        "value": "Atualize a disponibilidade dos artigos em encomendas não processadas"
      }]
    }),
    buttonText: strictLocalize({
      id: "zkYVp5",
      defaultMessage: [{
        "type": 0,
        "value": "Editar a disponibilidade do artigo"
      }]
    })
  }), QuickActionType.CANCEL_AN_ORDER, {
    title: (_quickActions$QuickAc4 = quickActions[QuickActionType.CANCEL_AN_ORDER]) === null || _quickActions$QuickAc4 === void 0 ? void 0 : _quickActions$QuickAc4.label,
    description: strictLocalize({
      id: "uw/QeA",
      defaultMessage: [{
        "type": 0,
        "value": "Cancelar uma encomenda que ainda não foi processada ou enviada"
      }]
    }),
    buttonText: strictLocalize({
      id: "sPg2u4",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar o cancelamento"
      }]
    })
  }), QuickActionType.TRACK_AN_ORDER, {
    title: (_quickActions$QuickAc5 = quickActions[QuickActionType.TRACK_AN_ORDER]) === null || _quickActions$QuickAc5 === void 0 ? void 0 : _quickActions$QuickAc5.label,
    description: strictLocalize({
      id: "vvqBDw",
      defaultMessage: [{
        "type": 0,
        "value": "Ver dados de monitorização de encomendas que foram enviadas"
      }]
    }),
    buttonText: strictLocalize({
      id: "uVSNXI",
      defaultMessage: [{
        "type": 0,
        "value": "Seguir encomenda"
      }]
    })
  }), QuickActionType.RETURN_ITEMS, {
    title: (_quickActions$QuickAc6 = quickActions[QuickActionType.RETURN_ITEMS]) === null || _quickActions$QuickAc6 === void 0 ? void 0 : _quickActions$QuickAc6.label,
    description: strictLocalize({
      id: "SM+WKr",
      defaultMessage: [{
        "type": 0,
        "value": "Devolva artigos de encomendas recebidas nos últimos 60 dias. Só pode ser devolvida a primeira encomenda de uma marca específica."
      }]
    }),
    buttonText: strictLocalize({
      id: "ylvEif",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar uma devolução"
      }]
    })
  }), QuickActionType.CONTACT_A_BRAND, {
    title: (_quickActions$QuickAc7 = quickActions[QuickActionType.CONTACT_A_BRAND]) === null || _quickActions$QuickAc7 === void 0 ? void 0 : _quickActions$QuickAc7.label,
    description: strictLocalize({
      id: "Tce2uo",
      defaultMessage: [{
        "type": 0,
        "value": "Entre em contacto com as marcas com perguntas específicas sobre o produto ou dúvidas sobre o tempo previsto para o processamento de uma encomenda. Esta é a melhor e mais rápida forma de resolver questões pendentes."
      }]
    }),
    buttonText: strictLocalize({
      id: "jHHKwS",
      defaultMessage: [{
        "type": 0,
        "value": "Contactar marca"
      }]
    })
  }), QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS, {
    title: (_quickActions$QuickAc8 = quickActions[QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS]) === null || _quickActions$QuickAc8 === void 0 ? void 0 : _quickActions$QuickAc8.label,
    description: strictLocalize({
      id: "95bnr6",
      defaultMessage: [{
        "type": 0,
        "value": "Comunique problemas com a sua encomenda no prazo de 14 dias após a entrega"
      }]
    }),
    buttonText: strictLocalize({
      id: "EfYP7O",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar relatório de danificado/em falta"
      }]
    })
  });
};